import { html, LitElement, TemplateResult } from 'lit';
import { property, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ImageName, ImageState } from '../types';

export class GzImageRepoWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({ type: String, attribute: true, reflect: true })
  state = ImageState.EMPTY;

  @state()
  image;

  @state()
  imageArray = new Map<ImageState, ImageName>([
    [ImageState.EMPTY, ImageName.EMPTY],
    [ImageState.ERROR, ImageName.ERROR],
    [ImageState.LOADING, ImageName.LOADING],
    [ImageState.START, ImageName.START],
    [ImageState.SUCCESS, ImageName.SUCCESS],
    [ImageState.DENIED, ImageName.DENIED],
    [ImageState.NO_IMAGE, ImageName.NO_IMAGE],
    [ImageState.NO_DATA_INTEGRATIONS, ImageName.NO_DATA_INTEGRATIONS],
  ]);

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  connectedCallback() {
    super.connectedCallback();

    this.image = this.imageArray.get(this.state);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    super.attributeChangedCallback(name, oldVal, newVal);

    if (name === 'state' && newVal) {
      this.updateComplete.then(() => {
        this.image = this.imageArray.get(this.state);
      });
    }
  }

  private renderImage(): TemplateResult {
    return html`
      ${this.state !== ImageState.NO_IMAGE ? html`<img class="image-repo--image" src="${this.image}" />` : ''}
    `;
  }

  render() {
    return html`
      <div class="image-repo--wrapper" part="wrapper">
        ${this.renderImage()}
        <div class="d-flex flex-column" part="slot-content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
